import React, { useRef } from "react";

type IdFile = File & { uid: string };

interface UploaderProps {
  onFilesSelected: (files: IdFile[]) => void;
  multiple?: boolean;
  accept?: string;
  children: (props: { openSystemFileDialog: () => void }) => React.ReactNode;
}

const Uploader: React.FC<UploaderProps> = ({
  onFilesSelected,
  multiple = false,
  accept = "*",
  children,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openSystemFileDialog = () => {
    inputRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const eventPayload: IdFile[] = Array.from(files).map((el) => {
        (el as IdFile).uid = generateUid();
        return el as IdFile;
      });
      console.log(eventPayload, eventPayload[0]);
      onFilesSelected(eventPayload);
      e.target.value = "";
    }
  };

  return (
    <>
      <input
        type="file"
        ref={inputRef}
        style={{ display: "none" }}
        onChange={handleChange}
        multiple={multiple}
        accept={accept}
      />
      {children({ openSystemFileDialog })}
    </>
  );
};

function generateUid() {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

export default Uploader;
